import dayjs from "dayjs";
import { useParcelHandoffs } from "../../store/useParcelHandoffs";
import { parcelSplit } from "../../utils/parcelSplit";

const nameOf = (person: any) =>
  [person?.first_name, person?.last_name].filter(Boolean).join(" ").trim();

export const ParcelHandoffsTable = () => {
  /** Hooks */
  const { parcelHandoffs } = useParcelHandoffs();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Customer
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Carrier
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Pickups
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Drop-offs
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Location
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Registered by
            </th>
          </tr>
        </thead>
        <tbody>
          {parcelHandoffs?.map((handoff) => {
            const customer: any = handoff?.user;
            const carrier: any = handoff?.carrierPartner;
            const location: any = handoff?.location;
            const staff: any = handoff?.registeredBy;
            // Zero is shown as 0 so both count columns always read as numbers.
            const split = parcelSplit(handoff);
            return (
              <tr key={handoff?._id} className="bg-white border-b">
                <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                  {dayjs(handoff?.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  <span className="block whitespace-nowrap">
                    {nameOf(customer) || "—"}
                  </span>
                  {/* Email when we have it, id otherwise: support searches by
                      whichever of the two the customer quoted. */}
                  <span className="block text-xs text-gray-600">
                    {customer?.email ?? String(customer?._id ?? customer ?? "")}
                  </span>
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  <div className="flex items-center gap-2">
                    {carrier?.thumbnail || carrier?.image ? (
                      <img
                        src={carrier?.thumbnail ?? carrier?.image}
                        alt={carrier?.name ?? "carrier"}
                        className="h-7 w-7 rounded-full object-cover"
                      />
                    ) : null}
                    <span className="whitespace-nowrap">
                      {carrier?.name ?? "—"}
                    </span>
                  </div>
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 text-right tabular-nums">
                  {split.pickup}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 text-right tabular-nums">
                  {split.dropoff}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {location?.name ?? location?.city ?? "—"}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {nameOf(staff) || staff?.email || "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
